/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actionCreator from '../../../../../../action/index';
import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import useMouseEvents from '../../../../../../hooks/useMouseEvents';
import { useLoader, useThree } from '@react-three/fiber';
import { NormalStripeImg } from '../../../../../../utils/Textures';
import { controls } from '../../../../../../redux/reducers/eventReducer';

const OutsideWallModel = () => {
    const dispatch = useDispatch();

    const leftWallCloseState = useSelector((state) => state.reducer.leftWallCloseState)
    
    // const [isRoofPanel, setIsRoofPanel] = useState(false);
    const [wallCloseState, setWallCloseState] = useState(0);
    // const [CSGWallModelGeometry, setCSGWallModelGeometry] = useState(null);
    // const [CSGWainscotModelGeometry, setCSGWainscotModelGeometry] = useState(null);
    
    const canvasElement = document.getElementsByClassName("building-size")
    const isPattern = (canvasElement != undefined && canvasElement[0] && canvasElement[0].clientWidth > 1050 && !params.p_v_w) ? true : false
    const wainscotColor = useMemo(() => (params.p_w_c_c.replace("0x","#")), [params.p_w_c_c])
    const { gl } = useThree();
    // const texture = const_var.wallTextureObj[params.wallTexture]
    
    const mainWallModel = useMemo(() => {
        let model = new THREE.Shape();

        if (wallCloseState > -1) {
            model.moveTo(-(params.p_d / 2 + 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) - 0.001 : params.p_h - 0.001);
            model.lineTo(params.p_d / 2 + 0.15, (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) - 0.001 : params.p_h - 0.001);
            model.lineTo(params.p_d / 2 + 0.15, wallCloseState);

            if(params.p_u_c) {
                model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, wallCloseState);
                model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, 0);
                model.lineTo(-(params.p_d / 2 + 0.15), 0);
            } else if(params.cB_addStorage_check_front) {
                model.lineTo(params.p_d / 2 + 0.15, 0);
                model.lineTo(params.p_d / 2 - parseInt(params.cB_addStorage_front), 0);
                model.lineTo(params.p_d / 2 - parseInt(params.cB_addStorage_front), wallCloseState);                
            }
            model.lineTo(-(params.p_d / 2 + 0.15), wallCloseState);
   
            model.closePath()
        } else {
            if (params.p_u_c) {
                model.moveTo(-(params.p_d / 2 + 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) - 0.001 : params.p_h - 0.001);
                model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) - 0.001 : params.p_h - 0.001);
                model.lineTo(-params.p_d / 2 + parseInt(params.p_u_t) + 0.02, 0);
                model.lineTo(-(params.p_d / 2 + 0.15), 0);
                model.closePath()
            } else if (params.cB_addStorage_check_front) {
                model.moveTo(params.p_d / 2 + 0.15, params.p_h - 0.001);
                model.lineTo(params.p_d / 2 - parseInt(params.cB_addStorage_front), params.p_h - 0.001);
                model.lineTo(params.p_d / 2 - parseInt(params.cB_addStorage_front), 0);
                model.lineTo(params.p_d / 2 + 0.15, 0);
                model.closePath()
            }
        }

        let verticalHorizontalPos = params.p_v_w == true ? {"x":-params.p_w / 2 - 0.005,"y": ((params.p_w_c_n && (params.p_l_w === 'Close' || params.p_u_c)) ? 2.935 : 0), "z":params.p_d / 2 + 0.15} : {"x": params.p_w / -2 - 0.005,"y" : ((params.p_w_c_n && (params.p_l_w === 'Close' || params.p_u_c)) ? 2.935 : 0), "z" : params.p_d / -2 - 0.15}
        let verticalHorizontalRot = params.p_v_w == true ? {"x":Math.PI / 2,"y" : Math.PI,"z" : Math.PI / -2} : {"x":0,"y" : 0,"z" : Math.PI / 2}
        let patternLength = params.p_v_w == true ? params.p_d + 0.3 : params.p_h - 0.01 + ((params.p_w_c_n && (params.p_l_w === 'Close' || params.p_u_c)) ? -2.935 : 0)
        let patternDepth = params.p_v_w == true ? params.p_h - 0.01 + ((params.p_w_c_n && (params.p_l_w === 'Close' || params.p_u_c)) ? -2.935 : 0) : params.p_d + 0.3
        
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength,isPattern), extrudeSettings(patternDepth)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('left', 'wall'), extrudeSettings(1)))
        const meshWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(model, extrudeSettings(1)))
    
        let meshWallModel_Temp = meshWallModel.clone();
        meshWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshWallModel_Temp.updateMatrixWorld();
    
        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(-params.p_w / 2 + 0.5, 0, 0);
        meshDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshDelModel_Temp.updateMatrixWorld();
    
        let meshWallDelModel_Temp = meshWallDelModel.clone();
        meshWallDelModel_Temp.position.set(-params.p_w / 2 + 0.5, 0, 0);
        meshWallDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshWallDelModel_Temp.updateMatrixWorld();
    
        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshWallDelModel_CSG = CSG.fromMesh(meshWallDelModel_Temp);
    
    
        const wallModel_CSG = meshWallModel_CSG.subtract(meshDelModel_CSG);
        const meshWallDel_CSG = wallModel_CSG.intersect(meshWallDelModel_CSG);
        const CSGWallModel = CSG.toMesh(
            meshWallDel_CSG,
            new THREE.Matrix4()
        )
    
        /************** cutting hole in wainscot using CSG ***************/
    
        // let verticalHorizontalWaingscotPos = params.p_v_w == true ? {"x":-params.p_w / 2 - 0.005,"y": 0, "z": params.p_l_w === 'Close' ? params.p_d / 2 + 0.15 : -params.p_d / 2 + parseInt(params.p_u_t)} : {"x": params.p_w / -2 - 0.005,"y" : 0, "z" : params.p_d / -2 - 0.15}
        // let verticalHorizontalWaingscotRot = params.p_v_w == true ? {"x":Math.PI / 2,"y" : Math.PI,"z" : Math.PI / -2} : {"x":0,"y" : 0,"z" : Math.PI / 2}
        // let patternLength = params.p_v_w == true ? params.p_d + 0.3 : params.p_h - 0.01
        // let patternDepth = params.p_v_w == true ? params.p_h - 0.01 : params.p_d + 0.3
        let wainscotVerticalHorizontalPos = params.p_v_w == true ? {"x":-params.p_w / 2 - 0.005,"y": 0, "z":params.p_d / 2 + 0.15} : {"x": params.p_w / -2 - 0.005,"y" : 0, "z" : params.p_d / -2 - 0.15}
        let wainscotVerticalHorizontalRot = params.p_v_w == true ? {"x":Math.PI / 2,"y" : Math.PI,"z" : Math.PI / -2} : {"x":0,"y" : 0,"z" : Math.PI / 2}
        let lengthPattern = (params.p_v_w && params.p_l_w === 'Close') ? (params.p_d + 0.3) : (params.p_v_w && params.p_l_w !== 'Close') ? params.p_d + 0.3 : 3
        let depthPattern = (params.p_v_w) ? 3 : params.p_l_w === 'Close' ? params.p_d + 0.3 : params.p_d + 0.3
        
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern,isPattern), extrudeSettings(depthPattern)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(wainscotVerticalHorizontalPos.x,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);
        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDelModel_CSG);
        const wainscotModelCSG = wainscotModel_CSG.intersect(meshWallDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(
            wainscotModelCSG,
            new THREE.Matrix4()
        )
    
        // setCSGWallModelGeometry(CSGWallModel.geometry);
        // setCSGWainscotModelGeometry(CSGWainscotModel.geometry);

        /****************************************** *********/

        return {
            wall: CSGWallModel.geometry,
            wainscot: CSGWainscotModel.geometry
        };
    
    }, [params.wallTexture,params.p_d, params.p_h, params.p_w, wallCloseState, params.p_u_c, parseInt(params.p_u_t), params.p_r_p,params.singleSlope && params.freeStandingSide === "left", params.p_w_c_n, params.p_l_w, params.p_v_w,const_var.newDoorsArray])

    useMemo(() => {
        var wallCloseValue = -1;
        var tempCutState = -1;
        let leanHeightValue = -1;
        let finalHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p/12) * params.p_w) : params.p_h
        if(params.cB_addStorage_check_left) params.p_l_w = 'Close'

        if (params.p_l_w === 'Open' || typeof(params.p_l_w) === 'object') {
            wallCloseValue = -1;
        } else if (params.p_l_w === "One_Fourth_Close") {
            wallCloseValue = (finalHeight * 3) / 4;
        } else if (params.p_l_w === "Half_Close") {
            wallCloseValue = finalHeight / 2;
        } else if (params.p_l_w === "Three_Fourth_Close") {
            wallCloseValue = finalHeight / 4;
        } else if (params.p_l_w === "Close") {
            wallCloseValue = 0;
        } else {
            wallCloseValue = finalHeight - (3 * params.p_l_w) - 0.2;
        }

        // if(params.p_w_c_n === true && params.p_l_w === "Close") wallCloseValue = 3

        if (params.p_c_p_l) {
            if (params.p_l_w === 'Open' || typeof(params.p_l_w) === 'object') {
                tempCutState = finalHeight - 1.5;
            } else {
                tempCutState = wallCloseValue - 1.5;
            }
        } else {
            tempCutState = wallCloseValue;
        }
        // if (params.cB_addStorage_check_left) {
        //     if(params.p_w_c_n)setWallCloseState(3)
        //     else setWallCloseState(0);
        // } else {
            if (params.add_left_lean) {
                let leanFinalHeight = params.p_h - (params.lean_p_h + (parseInt(params.b_l_t_r_p)/12) * params.lean_p_w);

                if(params.add_left_lean && leanFinalHeight > 0 &&  (Math.abs(params.p_l_w) * 3) -leanFinalHeight < 3)
                {    
                    let wH = leanFinalHeight+0.2;
                    tempCutState = params.p_h - wH
                    if (params.singleSlope) tempCutState = params.p_h  - (Number(params.p_r_p)/12) * params.p_w- wH
                } else {
                    if(isNaN(params.p_l_w) == false){
                        let wH = (3 * params.p_l_w) - 0.2;
                        tempCutState = finalHeight - wH
                        if (params.singleSlope) tempCutState = params.p_h  - (Number(params.p_r_p)/12) * params.p_w- wH
                    }   
                }

                if (params.p_c_p_l) {
                    dispatch(actionCreator.setLeftWallCloseState(tempCutState - 1.5, "left"));
                    setWallCloseState(tempCutState - 1.5);
                }else{
                    dispatch(actionCreator.setLeftWallCloseState(tempCutState, "left"));
                    setWallCloseState(tempCutState);
                }

            } else {
                /** cutting panel options isn't disabled when wall close state over limit */
                if (tempCutState > 0) {
                    setWallCloseState(tempCutState);
                    dispatch(actionCreator.setLeftWallCloseState(tempCutState, "left"));
                } else {
                    if (params.p_l_w === 'Open' || typeof(params.p_l_w) === 'object') {
                        setWallCloseState(-1);
                        dispatch(actionCreator.setLeftWallCloseState(-1, "left"));
                    } else {
                        setWallCloseState(0);
                        dispatch(actionCreator.setLeftWallCloseState(0, "left"));
                    }
                }
            }
        // }
    
    }, [params.p_l_w, params.p_c_p_l, params.p_h, params.p_w, params.add_left_lean, params.lean_p_h, params.lean_p_w, params.b_l_t_r_p, params.cB_addStorage_check_left, params.singleSlope && params.freeStandingSide === "left",params.p_w_c_n])

    // useMemo(() => {
    //     let panelHeight = (params.lean_p_h + (params.lean_p_w*(params.b_l_t_r_p/12))) - 0.2
    //     if(params.p_d != params.lean_p_d && leftWallCloseState == panelHeight){
    //         setIsRoofPanel(true)
    //     }else{
    //         setIsRoofPanel(true)
    //     }
    // }, [params.lean_p_w, params.lean_p_h, params.lean_p_d, params.p_d, params.p_h, params.b_l_t_r_p,leftWallCloseState])

    const mainColor = useMemo(() => (params.p_w_c.replace("0x","#")), [params.p_w_c])
    const handleMouseEvent = (e) => {
        if ((params.activeWall !== "c_b_r_s_l_w" && params.activeWall !== "R_L_L_S_W")) {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

    const texture = useMemo(() => {
        let texture = const_var.wallTextureObj[params.wallTexture];
        textureAnisotropy(gl, texture,(params.wallTexture == "board_batten")? 0.7 : 1.3, (params.wallTexture == "lap")? 0.5 : 1.3, Math.PI/-2);
        return texture
    }, [params.p_v_w,params.wallTexture])

    return (
        <group {...eventHandlers}>
            {(wallCloseState > -1 || params.p_u_c) &&
                <mesh name="c_b_l_w" geometry={mainWallModel.wall} >
                    <meshStandardMaterial aoMap={texture} aoMapIntensity={(params.p_v_w || !isPattern) ? 0.6 : (params.wallTexture == "board_batten") ? 1 :  (params.wallTexture == "lap")? 0.6 : 0}  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={(params.p_v_w || params.wallTexture != "none") ? 0 : 0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} needsUpdate={true}/>
                </mesh>
            }
            {(params.p_w_c_n === true && ((params.p_l_w === "Close") || ((params.p_u_c) && params.p_l_w !== "Close") || (params.cB_addStorage_check_left))) && mainWallModel.wainscot &&
                <mesh name="c_b_l_w_wainscot" geometry={mainWallModel.wainscot} position={[-0.005,0,0]}>
                    <meshStandardMaterial aoMap={texture} aoMapIntensity={(params.p_v_w || !isPattern) ? 0.6 : (params.wallTexture == "board_batten") ? 1 :  (params.wallTexture == "lap")? 0.6 : 0}  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={(params.p_v_w || params.wallTexture != "none") ? 0 : 0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} needsUpdate={true}/>
                </mesh>
            } 
        </group>
    )
}

export default OutsideWallModel